import { DialogService, GridAction } from '@eforall/dashboard';
import { AccTeamDialog, PersonDialog, VolunteerDialog } from '../../../../widget';
import { AccMentorDropout, MentorDropoutsGridServiceInterface } from '../mentor-dropouts-grid.part';

export function getActions(dialogService: DialogService, service: MentorDropoutsGridServiceInterface): GridAction<AccMentorDropout>[] {

	const actions: GridAction<AccMentorDropout>[] = [
		{
			iconClass: 'fa-regular fa-file-lines',
			label: 'View Team Details',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialogService.showCustom(AccTeamDialog, { data: { accTeamId: rows[0]!.accTeamId } }, 900, 900);
				await service.areaService.reloadData();
			}
		},
		{
			iconClass: 'fa-regular fa-user-tie',
			label: 'View Volunteer Details',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialogService.showCustom(VolunteerDialog, { data: { volunteerId: rows[0]!.volunteerId } }, 900, 900);
			}
		},
		{
			iconClass: 'fa-regular fa-pencil',
			label: 'View Person Details',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialogService.showCustom(PersonDialog, { data: { personId: rows[0]!.personId, toEdit: false } }, 800, 800);
			}
		},
	];

	return actions;
}